import Plyr from 'plyr'

const els = document.querySelectorAll('.feed-video__player')

const instances = []
els.forEach((el) => {
  if (el.__plyr) return

  const player = new Plyr(el, {
    ratio: '1:1',
    controls: [
      'play-large',
      'play',
      'progress',
      'current-time',
      'mute',
      'volume',
      'captions',
      'fullscreen',
    ],
    captions: { active: true, update: true },
  })

  el.__plyr = player
  instances.push(player)
})

window.feedPlyr = instances
